import React, { FunctionComponent } from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

import { FieldLabel } from './FieldLabel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
  })
);

export interface FieldSwitchProps {
  value?: unknown;
  checked?: boolean;
  onChange?: (event: FieldSwitchChange) => void;
  label?: React.ReactNode;
  helpText?: React.ReactNode;
  disabled?: boolean;
  multiple?: boolean;
  name: string;
  required?: boolean;
  placeholder?: string;
  error?: string;
  size?: 'small';
}

export type FieldSwitchChange = {
  name: string;
  value: boolean;
};

export const FieldSwitch: FunctionComponent<FieldSwitchProps> = (
  props: FieldSwitchProps
) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const handleChange = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown | undefined;
    }>,
    checked: boolean
  ) => {
    if (props.onChange) {
      props.onChange({ name: props.name, value: checked });
    }
  };

  return (
    <FormControl
      className={classes.formControl}
      variant='outlined'
      required={props.required}
      disabled={props.disabled}
      margin='dense'
    >
      <FormControlLabel
        control={
          <Switch
            size={props.size}
            disabled={props.disabled}
            key={props.name}
            name={props.name}
            value={props.value}
            checked={props.checked}
            onChange={handleChange}
            required={props.required}
          />
        }
        label={<FieldLabel label={props.label} helpText={props.helpText} />}
      />
      <FormHelperText error={true}>{props.error}</FormHelperText>
    </FormControl>
  );
};
